import { createStyledBreakpointsTheme } from "styled-breakpoints";

export const breakPointsTheme = createStyledBreakpointsTheme({
    breakpoints:{
        xs: '0px',
        sm: '640px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
        xxl: '1536px',
    }
})